<template>
	<div class="cloudlinker-stat-page">
		<div class="overview-banner">
			<h2>CloudLinker 运维审计报告</h2>
			<p>{{ ($route.query.time_from * 1000) | moment('YYYY-MM-DD HH:mm:ss') }} ~ {{ ($route.query.time_end * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</p>
		</div>
		<!-- 顶部概览卡片 -->
		<div class="overview-cards">
			<div class="overview-card">
				<div>
					<i class="material-icons assess-color">assessment</i>
				</div>
				<div class="card-title">资源</div>
				<div class="card-value assess-color">{{ overviewData.resources }}</div>
			</div>
			<div class="overview-card">
				<div>
					<i class="material-icons work-color">dvr</i>
				</div>
				<div class="card-title">工作组</div>
				<div class="card-value work-color">{{ overviewData.projects }}</div>
			</div>
			<div class="overview-card">
				<div>
					<i class="material-icons cluster-color">view_list</i>
				</div>
				<div class="card-title">集群</div>
				<div class="card-value cluster-color">{{ overviewData.networks }}</div>
			</div>
			<div class="overview-card">
				<div>
					<i class="material-icons member-color">group</i>
				</div>
				<div class="card-title">成员</div>
				<div class="card-value member-color">{{ overviewData.accounts }}</div>
			</div>
		</div>

		<!-- 统计指标行 -->
		<div class="stat-row">
			<div class="stat-item">
				<div class="item-label">活跃用户数</div>
				<div class="item-value">{{ statRowData.conn_account_count }}</div>
			</div>
			<div class="stat-item">
				<div class="item-label">被访问资源数</div>
				<div class="item-value">{{ statRowData.resource_count }}</div>
			</div>
			<div class="stat-item">
				<div class="item-label">总连接次数</div>
				<div class="item-value">{{ statRowData.conn_count }}</div>
			</div>
			<div class="stat-item">
				<div class="item-label">指令告警次数</div>
				<div class="item-value">{{ statRowData.notice_count }}</div>
			</div>
			<div class="stat-item">
				<div class="item-label">日均连接次数</div>
				<div class="item-value">{{ statRowData.avg_days_conn_count }}</div>
			</div>
			<div class="stat-item">
				<div class="item-label">总连接时长</div>
				<div class="item-value">{{ statRowData.conn_time }}小时</div>
			</div>
			<div class="stat-item">
				<div class="item-label">日均连接时长</div>
				<div class="item-value">{{ statRowData.avg_days_conn_time }}小时</div>
			</div>
			<div class="stat-item">
				<div class="item-label">平均连接时长</div>
				<div class="item-value">{{ statRowData.avg_conn_time }}小时</div>
			</div>
		</div>

		<div class="chart-group">
			<!-- 连接次数-饼图 -->
			<Echarts type="pie" :options="connectCountPie" width="40%" height="300px" />
			<!-- 连接次数-折线图 -->
			<Echarts type="line" :options="connectCountLine" width="60%" height="300px" />
		</div>

		<div class="chart-group">
			<!-- 连接时长-饼图 -->
			<Echarts type="pie" :options="connectTimePie" width="40%" height="300px" />
			<!-- 连接时长-折线图 -->
			<Echarts type="line" :options="connectTimeLine" width="60%" height="300px" />
		</div>

		<div class="chart-group">
			<!-- 告警指令-TOP5表格 -->
			<div style="width: 40%">
				<p>告警指令TOP5</p>
				<el-table :data="alertTopTable" height="400">
					<el-table-column label="指令" prop="match_command"></el-table-column>
					<el-table-column label="次数" prop="count"></el-table-column>
					<el-table-column label="占比" prop="proportion">
						<template scope="scope">
							<el-progress :percentage="scope.row.proportion"></el-progress>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 告警指令-多折线图 -->
			<Echarts type="line" :options="alertMultiLine" width="60%" height="400px" />
		</div>

		<div class="top-list-group">
			<!-- 成员连接次数TOP10 -->
			<div style="width: 30%">
				<p>成员连接次数TOP10</p>
				<el-table :data="memberConnectTop" height="400" show-overflow-tooltip>
					<el-table-column label="成员" prop="name">
						<template scope="scope">
							<div class="flex items-center">
								<img :src="scope.row.avatar | resetURL" class="avatar-img" />
								<span>{{ scope.row.name }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="次数" prop="conn_count"></el-table-column>
					<el-table-column label="占比" prop="proportion">
						<template scope="scope">
							<el-progress :percentage="scope.row.proportion"></el-progress>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 资源连接次数TOP10 -->
			<div style="width: 70%">
				<p>资源连接次数TOP10</p>
				<el-table :data="resourceConnectTop" height="400" show-overflow-tooltip>
					<el-table-column label="资源" prop="resource_name">
						<template scope="scope">
							<div class="flex items-center">
								<el-tooltip v-if="scope.row.os === 'linux'" class="item" effect="dark" content="Linux" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/linux.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os === 'win32'" class="item" effect="dark" content="Windows" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/win32.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'postgresql'" class="item" effect="dark" content="PostgreSQL" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/postgresql.png`" width="16" height="16" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'mysql'" class="item" effect="dark" content="MySQL" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/mysql.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'mssql'" class="item" effect="dark" content="SQL Server" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/mssql.png`" alt="" />
								</el-tooltip>

								<p class="truncate">{{ scope.row.resource_name }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="集群" prop="network_name"></el-table-column>
					<el-table-column label="IP地址" prop="ip_address"></el-table-column>
					<el-table-column label="次数" prop="conn_count"></el-table-column>
					<el-table-column label="占比" prop="proportion">
						<template scope="scope">
							<el-progress :percentage="scope.row.proportion"></el-progress>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<div class="top-list-group">
			<!-- 成员连接时长TOP10 -->
			<div style="width: 30%">
				<p>成员连接时长TOP10</p>
				<el-table :data="memberTimeTop" height="400" show-overflow-tooltip>
					<el-table-column label="成员" prop="name">
						<template scope="scope">
							<div class="flex items-center">
								<img :src="scope.row.avatar | resetURL" class="avatar-img" />
								<span>{{ scope.row.name }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="时长" prop="conn_time">
						<template scope="scope">{{ (scope.row.conn_time / 3600).toFixed(2) }}小时</template>
					</el-table-column>
					<el-table-column label="占比" prop="proportion">
						<template scope="scope">
							<el-progress :percentage="scope.row.proportion"></el-progress>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!-- 资源连接时长TOP10 -->
			<div style="width: 70%">
				<p>资源连接时长TOP10</p>
				<el-table :data="resourceTimeTop" height="400" show-overflow-tooltip>
					<el-table-column label="资源" prop="resource_name">
						<template scope="scope">
							<div class="flex items-center">
								<el-tooltip v-if="scope.row.os === 'linux'" class="item" effect="dark" content="Linux" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/linux.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os === 'win32'" class="item" effect="dark" content="Windows" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/win32.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'postgresql'" class="item" effect="dark" content="PostgreSQL" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/postgresql.png`" width="16" height="16" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'mysql'" class="item" effect="dark" content="MySQL" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/mysql.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'mssql'" class="item" effect="dark" content="SQL Server" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/mssql.png`" alt="" />
								</el-tooltip>

								<p class="truncate">{{ scope.row.resource_name }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="集群" prop="network_name"></el-table-column>
					<el-table-column label="IP地址" prop="ip_address"></el-table-column>
					<el-table-column label="时长" prop="conn_time">
						<template scope="scope">{{ (scope.row.conn_time / 3600).toFixed(2) }}小时</template>
					</el-table-column>
					<el-table-column label="占比" prop="proportion">
						<template scope="scope">
							<el-progress :percentage="scope.row.proportion"></el-progress>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<div class="top-list-group">
			<!-- 指令告警次数TOP10 -->
			<div style="width: 30%">
				<p>指令告警次数/成员TOP10</p>
				<el-table :data="alertMemberTop" height="400" show-overflow-tooltip>
					<el-table-column label="成员" prop="account_name">
						<template scope="scope">
							<div class="flex items-center">
								<img :src="scope.row.avatar | resetURL" class="avatar-img" />
								<span>{{ scope.row.account_name }}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="次数" prop="count"></el-table-column>
					<el-table-column label="占比" prop="proportion">
						<template scope="scope">
							<el-progress :percentage="scope.row.proportion"></el-progress>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!-- 指令告警次数/资源TOP10 -->
			<div style="width: 70%">
				<p>指令告警次数/资源TOP10</p>
				<el-table :data="resourceAlertTop" height="400" show-overflow-tooltip>
					<el-table-column label="资源" prop="resource_name">
						<template scope="scope">
							<div class="flex items-center">
								<el-tooltip v-if="scope.row.os === 'linux'" class="item" effect="dark" content="Linux" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/linux.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os === 'win32'" class="item" effect="dark" content="Windows" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/win32.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'postgresql'" class="item" effect="dark" content="PostgreSQL" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/postgresql.png`" width="16" height="16" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'mysql'" class="item" effect="dark" content="MySQL" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/mysql.png`" alt="" />
								</el-tooltip>

								<el-tooltip v-if="scope.row.os == 'mssql'" class="item" effect="dark" content="SQL Server" placement="top">
									<img style="margin-right: 5px" :src="`../../static/images/mssql.png`" alt="" />
								</el-tooltip>

								<p class="truncate">{{ scope.row.resource_name }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="集群" prop="network_name"></el-table-column>
					<el-table-column label="IP地址" prop="resource_ip_address"></el-table-column>
					<el-table-column label="次数" prop="count"></el-table-column>
					<el-table-column label="占比" prop="proportion">
						<template scope="scope">
							<el-progress :percentage="scope.row.proportion"></el-progress>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import Echarts from '@/components/common/echarts.vue'

import STORE_CONST from '@/store/consts'
import moment from '../../node_modules/moment'

// 【关键】原图配色方案（与图中一致）
const THEME_COLORS = {
	// 饼图配色（与图中资源类型颜色对应）
	pie: ['#1890ff', '#722ed1', '#00c48c', '#fa8c16', '#f5222d'],
	// 折线图主色（图中浅蓝色）
	line: '#4895ef',
	// 多折线图配色（图中不同资源类型的折线色）
	multiLine: ['#4895ef', '#fa8c16', '#00c48c', '#722ed1'],
	// 柱状图主色（图中蓝色）
	bar: '#1890ff',
}

export default {
	components: { Echarts },

	data() {
		return {
			accountList: [],

			// 【替换1】顶部概览数据
			overviewData: {
				resources: 0,
				projects: 0,
				networks: 0,
				accounts: 0,
			},
			// 【替换2】统计指标行数据
			statRowData: {
				conn_account_count: 0,
				resource_count: 0,
				conn_count: 0,
				notice_count: 0,
				avg_days_conn_count: 0,
				conn_time: '0',
				avg_days_conn_time: '0',
				avg_conn_time: '0',
			},

			// 1. 连接次数-饼图配置
			connectCountPie: {
				title: { text: '连接次数/资源类型', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: { trigger: 'item', formatter: '{b}: {c} （{d}%）' },
				legend: {
					show: false,
					type: 'scroll',
					orient: 'vertical',
					right: 10,
					top: 20,
					formatter: (name) => {
						const item = this.connectCountPie.series[0].data.find((i) => i.name === name)
						return `${name}\n${item.value} (${item.percent}%)`
					},
				},
				series: [
					{
						name: '连接次数',
						radius: ['30%', '60%'],
						center: ['50%', '50%'],
						// 显示饼图标签（与虚线标注配套）
						label: {
							show: true,
							position: 'outside', // 标签显示在饼图外侧，与虚线末端对齐
							// 开启富文本
							rich: {
								line1: {
									align: 'left',
									width: 80, // 固定宽度，确保换行后对齐
								},
								line2: {
									align: 'left',
								},
							},
							formatter: '{line1|{b}}\n{line2|{c} ({d}%)}',
							fontSize: 12,
						},
						// 核心配置：饼图虚线标注
						labelLine: {
							show: true, // 启用虚线标注
							smooth: false, // 标注线为直线，不弯曲
							length: 10, // 第一段标注线长度（从饼图边缘到转折点）
							length2: 30, // 第二段标注线长度（从转折点到标签）
							lineStyle: {
								type: 'dashed', // 线条类型：虚线
								color: '#666', // 虚线颜色：深灰色，与原图一致
								width: 1, // 虚线宽度：1px，保持纤细美观
							},
							// 隐藏无数据的标注线（优化冗余显示）
							silent: true,
							showAbove: true, // 标注线显示在饼图上方，不被遮挡
						},
						itemStyle: {
							color: (params) => THEME_COLORS.pie[params.dataIndex % THEME_COLORS.pie.length],
						},
						// 【替换3】连接次数饼图数据
						data: [
							{ name: 'MySQL', value: 13, percent: 6 },
							{ name: 'SQL server', value: 13, percent: 6 },
							{ name: 'PostgreSQL', value: 13, percent: 6 },
							{ name: 'Windows(RDP)', value: 13, percent: 6 },
							{ name: 'Linux(SSH)', value: 13, percent: 6 },
						],
					},
				],
			},

			// 2. 连接次数-折线图配置
			connectCountLine: {
				title: { text: '连接次数', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000', // 黑色背景
					textStyle: { color: '#fff', fontSize: 12 }, // 白色文字
					padding: 10, // 内边距
					borderRadius: 4, // 圆角
					// 核心：自定义 formatter 生成多行带颜色圆点的列表
					formatter: (params) => {
						// 1. 拼接顶部时间
						let html = `<div style="margin-bottom:8px;">${params[0].axisValue}</div>`
						// 2. 遍历每个系列，生成带颜色圆点的条目
						params.forEach((item) => {
							// 彩色圆点样式：与系列颜色一致
							const dot = `<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:${item.color}; margin-right:6px;"></span>`
							// 拼接条目：圆点 + 名称 + 数值
							html += `<div style="line-height:1.8;">${dot}${item.seriesName}：${item.value}</div>`
						})
						return html
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } },
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%', containLabel: true },
				xAxis: {
					// 【替换4】连接次数折线图X轴
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30'],
				},
				yAxis: { type: 'value', min: 0 },
				series: [
					{
						name: '连接次数',
						symbol: 'circle',
						symbolSize: 6,
						smooth: false,
						lineStyle: { width: 2, color: THEME_COLORS.line },
						itemStyle: { color: THEME_COLORS.line },
						// 【替换5】连接次数折线图数据
						data: [15, 15, 0, 30, 15, 60, 30, 15, 15, -5, 0, 5],
					},
				],
			},

			// 3. 连接时长-饼图配置（与连接次数饼图结构一致，仅替换数据）
			connectTimePie: {
				title: { text: '连接时长（小时）/资源类型', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: { trigger: 'item', formatter: '{b}: {c}小时 ({d}%)' },
				legend: {
					show: false,
					type: 'scroll',
					orient: 'vertical',
					right: 10,
					top: 20,
					formatter: (name) => {
						const item = this.connectTimePie.series[0].data.find((i) => i.name === name)
						return `${name}\n${item.value}小时 (${item.percent}%)`
					},
				},
				series: [
					{
						name: '连接时长',
						radius: ['30%', '60%'],
						center: ['50%', '60%'],
						// 显示饼图标签（与虚线标注配套）
						label: {
							show: true,
							position: 'outside', // 标签显示在饼图外侧，与虚线末端对齐
							// 开启富文本
							rich: {
								line1: {
									align: 'left',
									width: 80, // 固定宽度，确保换行后对齐
								},
								line2: {
									align: 'left',
								},
							},
							formatter: '{line1|{b}}\n{line2|{c} ({d}%)}',
							fontSize: 12,
						},
						// 核心配置：饼图虚线标注
						labelLine: {
							show: true, // 启用虚线标注
							smooth: false, // 标注线为直线，不弯曲
							length: 10, // 第一段标注线长度（从饼图边缘到转折点）
							length2: 30, // 第二段标注线长度（从转折点到标签）
							lineStyle: {
								type: 'dashed', // 线条类型：虚线
								color: '#666', // 虚线颜色：深灰色，与原图一致
								width: 1, // 虚线宽度：1px，保持纤细美观
							},
							// 隐藏无数据的标注线（优化冗余显示）
							silent: true,
							showAbove: true, // 标注线显示在饼图上方，不被遮挡
						},
						itemStyle: {
							color: (params) => THEME_COLORS.pie[params.dataIndex % THEME_COLORS.pie.length],
						},
						// 【替换6】连接时长饼图数据
						data: [
							{ name: 'MySQL', value: 13, percent: 6 },
							{ name: 'SQL server', value: 13, percent: 6 },
							{ name: 'PostgreSQL', value: 13, percent: 6 },
							{ name: 'Windows(RDP)', value: 13, percent: 6 },
							{ name: 'Linux(SSH)', value: 13, percent: 6 },
						],
					},
				],
			},

			// 4. 连接时长-折线图配置（与连接次数折线图结构一致，仅替换数据）
			connectTimeLine: {
				title: { text: '连接时长（小时）', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000', // 黑色背景
					textStyle: { color: '#fff', fontSize: 12 }, // 白色文字
					padding: 10, // 内边距
					borderRadius: 4, // 圆角
					// 核心：自定义 formatter 生成多行带颜色圆点的列表
					formatter: (params) => {
						// 1. 拼接顶部时间
						let html = `<div style="margin-bottom:8px;">${params[0].axisValue}</div>`
						// 2. 遍历每个系列，生成带颜色圆点的条目
						params.forEach((item) => {
							// 彩色圆点样式：与系列颜色一致
							const dot = `<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:${item.color}; margin-right:6px;"></span>`
							// 拼接条目：圆点 + 名称 + 数值
							html += `<div style="line-height:1.8;">${dot}${item.seriesName}：${item.value}</div>`
						})
						return html
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } },
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%', containLabel: true },
				xAxis: {
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30'],
				},
				yAxis: { type: 'value', min: 0 },
				series: [
					{
						name: '连接时长',
						symbol: 'circle',
						symbolSize: 6,
						smooth: false,
						lineStyle: { width: 2, color: THEME_COLORS.line },
						itemStyle: { color: THEME_COLORS.line },
						// 【替换7】连接时长折线图数据
						data: [15, 15, 0, 30, 15, 60, 30, 15, 15, -5, 0, 5],
					},
				],
			},

			// 5. 告警指令-TOP5表格
			alertTopTable: [],

			// 6. 告警指令-多折线图
			alertMultiLine: {
				title: { text: '告警指令（类型/次数/日期）', left: 'left', textStyle: { fontSize: 14 } },
				tooltip: {
					trigger: 'axis',
					backgroundColor: '#000', // 黑色背景
					textStyle: { color: '#fff', fontSize: 12 }, // 白色文字
					padding: 10, // 内边距
					borderRadius: 4, // 圆角
					// 核心：自定义 formatter 生成多行带颜色圆点的列表
					formatter: (params) => {
						// 1. 拼接顶部时间
						let html = `<div style="margin-bottom:8px;">${params[0].axisValue}</div>`
						// 2. 遍历每个系列，生成带颜色圆点的条目
						params.forEach((item) => {
							// 彩色圆点样式：与系列颜色一致
							const dot = `<span style="display:inline-block; width:8px; height:8px; border-radius:50%; background:${item.color}; margin-right:6px;"></span>`
							// 拼接条目：圆点 + 名称 + 数值
							html += `<div style="line-height:1.8;">${dot}${item.seriesName}：${item.value}</div>`
						})
						return html
					},
					axisPointer: { type: 'line', lineStyle: { color: '#999' } },
				},
				legend: { top: 'top', right: 'center', show: false },
				grid: { left: '5%', right: '5%', bottom: '10%', containLabel: true },
				xAxis: {
					data: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30'],
				},
				yAxis: { type: 'value' },
				series: [],
			},

			// 7. 成员连接次数TOP10
			memberConnectTop: [],

			// 8. 成员连接时长TOP10
			memberTimeTop: [],

			// 9. 指令告警次数/成员TOP10
			alertMemberTop: [],

			// 10. 资源连接次数TOP10
			resourceConnectTop: [],

			// 11. 资源连接时长TOP10
			resourceTimeTop: [],

			// 12. 资源告警次数TOP10
			resourceAlertTop: [],
		}
	},
	methods: {
		async getStatisticSummary(params) {
			return this.$store.dispatch(STORE_CONST.DASHBOARD.GET_STATISTIC_SUMMARY, params).then((res) => {
				console.log(res, 'res')
				for (let k in this.overviewData) {
					this.overviewData[k] = res[k]
				}

				for (let k in this.statRowData) {
					this.statRowData[k] = res[k]
					if (['conn_time', 'avg_days_conn_time', 'avg_conn_time'].includes(k)) {
						this.statRowData[k] = (res[k] / 3600).toFixed(2)
					}
				}

				// 1. 连接次数-饼图配置
				this.connectCountPie.series[0].data = res.resource_type_conn_count.map((item) => {
					for (let k in item) {
						return {
							name: k,
							value: item[k],
						}
					}
				})

				// 2. 连接次数-折线图配置
				this.connectCountLine.xAxis.data = res.conversation.map((item) => item.date)
				this.connectCountLine.series[0].data = res.conversation.map((item) => item.conn_count)

				// 3. 连接时长-饼图配置（与连接次数饼图结构一致，仅替换数据）
				this.connectTimePie.series[0].data = res.resource_type_conn_time.map((item) => {
					for (let k in item) {
						return {
							name: k,
							value: item[k],
						}
					}
				})

				// 4. 连接时长-折线图配置（与连接次数折线图结构一致，仅替换数据）
				this.connectTimeLine.xAxis.data = res.conversation.map((item) => item.date)
				this.connectTimeLine.series[0].data = res.conversation.map((item) => item.conn_time)

				// 5. 告警指令-TOP5表格
				this.alertTopTable = res.match_command || []

				// 6. 告警指令-多折线图
				this.alertMultiLine.xAxis.data = res.notice_command.map((item) => item.day)

				const resourceTypes = [
					{ name: 'MSSQL', color: '#f5222d' },
					{ name: 'MySQL', color: '#722ed1' },
					{ name: 'PostgreSQL', color: '#00c48c' },
					{ name: 'Windows（RDP）', color: '#fa8c16' },
					{ name: 'Linux（SSH）', color: '#4895ef' },
				]
				this.alertMultiLine.series = resourceTypes.map((type) => {
					return {
						name: type.name,
						type: 'line',
						smooth: false,
						itemStyle: { color: type.color },
						lineStyle: { color: type.color },
						data: res.notice_command.map((item) => item[type.name]),
					}
				})

				// 7. 成员连接次数TOP10
				this.memberConnectTop = res.account_conn_count || []

				// 8. 成员连接时长TOP10
				this.memberTimeTop = res.account_conn_time || []

				// 9. 指令告警次数/成员TOP10
				this.alertMemberTop = res.alarm_account_count || []

				// 10. 资源连接次数TOP10
				this.resourceConnectTop = res.resource_conn_count || []

				// 11. 资源连接时长TOP10
				this.resourceTimeTop = res.resource_conn_time || []

				// 12. 指令告警次数/资源TOP10
				this.resourceAlertTop = res.alarm_resource_count || []
			})
		},
	},
	async mounted() {
		console.log(this.$route.query, 'query')

		await this.getStatisticSummary(this.$route.query)
		document.title = `CloudLinker 运维审计报告_${moment(this.$route.query.time_from * 1000).format('YYYY-MM-DD')}_${moment(this.$route.query.time_end * 1000).format('YYYY-MM-DD')} `
		setTimeout(() => {
			window.print()
		}, 1000)
	},
}
</script>

<style scoped lang="scss">
.cloudlinker-stat-page {
	padding: 20px;
	background: #fff;
	max-width: 1200px;
	margin: 0 auto;
}

.overview-banner {
	color: black;
	text-align: center;
	margin-bottom: 40px;
	h2 {
		font-size: 36px;
		margin-bottom: 10px;
	}
	p {
		font-size: 20px;
	}
}
/* 顶部概览卡片 */
.overview-cards {
	display: flex;
	gap: 20px;
	margin-bottom: 20px;
	.overview-card {
		flex: 1;
		text-align: center;
		padding: 15px;
		border: 1px solid #eee;
		.material-icons {
			font-size: 36px;
		}
		.assess-color {
			color: #5a96ff;
		}
		.work-color {
			color: #ffc770;
		}
		.cluster-color {
			color: #6cdaa1;
		}
		.member-color {
			color: #b48cf7;
		}

		.card-title {
			font-size: 14px;
			color: #666;
			margin-bottom: 5px;
		}
		.card-value {
			font-size: 24px;
			font-weight: bold;
			color: #333;
		}
	}
}

/* 统计指标行 */
.stat-row {
	display: flex;
	flex-wrap: wrap;
	border: 1px solid #eee;
	margin-bottom: 20px;
}
.stat-item {
	flex: 1;
	min-width: 120px;
	padding: 10px;
	text-align: center;
	border-right: 1px solid #eee;
}
.stat-item:last-child {
	border-right: none;
}
.item-label {
	font-size: 12px;
	color: #666;
}
.item-value {
	font-size: 14px;
	color: #333;
	margin-top: 5px;
}

/* 图表组（饼图+折线图） */
.chart-group,
/* TOP10列表组 */
.top-list-group {
	display: flex;
	gap: 20px;
	margin-bottom: 20px;
	p {
		color: #2f2f2f;
		font-weight: 500;
		margin: 2px 0 10px;
	}
	.el-table {
		.el-table__body-wrapper {
			overflow-y: auto !important;
		}
		.cell {
			white-space: nowrap;

			.avatar-img {
				width: 20px;
				height: 20px;
				margin-right: 5px;
			}

			p {
				margin: 0;
				font-weight: normal;
			}
		}
	}

	.truncate {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}
</style>

<style lang="scss">
// 打印全局重置
@media print {
	// 1. 基础设置：A4尺寸、无边距、禁用自动分页
	@page {
		size: A3 portrait; // 纵向A4（portrait），横向可改为landscape
		margin: 5mm; // 页边距（避免内容被裁剪）
	}

	// 2. 全局样式重置
	body {
		margin: 0;
		padding: 0;
		font-size: 12px; // 打印字体适配
		color: #000 !important; // 强制黑色文字（部分打印机不识别彩色）
		background: #fff !important; // 强制白色背景
		-webkit-print-color-adjust: exact; // 强制打印颜色（兼容Chrome）
		print-color-adjust: exact; // 标准属性
	}

	// 3. 页面容器适配
	.cloudlinker-stat-page {
		max-width: 100% !important;
		padding: 0 !important;
		margin: 0 auto !important;
		background: #fff !important;
	}
}
</style>



// WEBPACK FOOTER //
// overviewExportPdf.vue?5237e20f